import { Injectable } from '@angular/core';
import {
  PushNotifications,
  PushNotificationSchema,
  ActionPerformed,
  Token
} from '@capacitor/push-notifications';
import { AppDataService } from './app-data.service';
import { Storage } from '@ionic/storage-angular';
import { Router, NavigationExtras } from '@angular/router';
import { Device } from '@capacitor/device';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationService {
  counter = 0;
  navigationExtras: NavigationExtras = {};
  constructor(private dataService: AppDataService,
    private storage: Storage,
    private router: Router,
  ) { }

  initPushNotification(user) {
    // console.log('initPushNotification', user);
    // Request permission to use push notificaiton
    // iOS will promt user and return if they granted Permission or not
    // Android will just grant without promting

    PushNotifications.requestPermissions().then((result) => {
      if (result.receive === 'granted') {
        // Register with Apple/Google to receive push via APNS/FCM
        PushNotifications.register();
      } else {
        // show some error

        // console.log('Permission Rejected', result);
      }
    });

    // On success, we should be able to receive notification
    PushNotifications.addListener(
      'registration',
      (token: Token) => {
        // console.log('Push registration success, token: ' + token.value);

        if (token.value && this.counter === 0) {
          this.counter++;
          this.updateDeviceTokenInDirectus(token.value);
        }
      }
    );

    // Some issue with our setup and push will not work
    PushNotifications.addListener(
      'registration',
      (token: Token) => {
        console.log('Push registration success, token: ' + token.value);

        console.log(token.value);
        this.storage.set("deviceToken", token.value)
        if (token.value && this.counter === 0) {
          this.counter++;
          this.updateDeviceTokenInDirectus(token.value);
        }
      }
    );

    // Show us the notification payload if the app is open on our device.
    PushNotifications.addListener(
      'pushNotificationReceived',
      async (notification: PushNotificationSchema) => {
        // await Toast.show({
        //   text
        // })
        // console.log('Push Received: ', JSON.stringify(notification));
      }
    );

    // Method called when tapping on the notification
    PushNotifications.addListener('pushNotificationActionPerformed', (notification: ActionPerformed) => {
      // console.log('Push action performed', notification);
      // PushNotifications.removeAllDeliveredNotifications();
      if (notification.notification.data.payload)
        var payload = JSON.parse(notification.notification.data.payload)
      this.dataService.routData = payload;
      this.dataService.routPath = 'notifications/Notifications/notification-detail';
      this.navigationExtras.state = {
        url: 'notifications/Notifications',
        ...payload,
      };
      this.router.navigate([`notifications/Notifications/notification-detail`], this.navigationExtras);
    });
  }

  updateDeviceTokenInDirectus(token) {
    const collectionName = 'device_token_notification';
    this.dataService
      .getData(collectionName)
      .then(async (res: any) => {
        this.counter = 0;
        const deviceInfo = await Device.getInfo();
        const deviceId = await Device.getId();
        const user = (await this.storage.get('userId')) ?? '';
        const user_role = (await this.storage.get('userType')) ?? '';
        let rowId = 0;
        if (res.data.length) {
          res.data.forEach(async row => {
            if (row.phone_uuid === deviceId.uuid) {
              rowId = row.id;
            }
          });
          if (rowId) {
            const updateToken = await this.dataService.updateItem(
              collectionName,
              rowId,
              {
                device_token: token,
                user_role: user_role,
                user
              }
            );
            // console.log('Updated Token', updateToken);
          } else {
            this.createDeviceTokenInDirectus(token, deviceInfo, +user, user_role, deviceId);
          }
        } else {
          this.createDeviceTokenInDirectus(token, deviceInfo, +user, user_role, deviceId);
        }
      })
      .catch((error) => {
        this.counter = 0;
        // console.log(
        //   'Error while getting data inside push Notification Service',
        //   error
        // );
      });
  }
  createDeviceTokenInDirectus(token, deviceInfo, user, user_role, deviceId): void {
    this.dataService.addNewItem(
      'device_token_notification',
      {
        user,
        user_role,
        device_token: token,
        phone_appbuild: deviceInfo.appBuild,
        phone_appversion: deviceInfo.appVersion,
        phone_isvirtual: deviceInfo.isVirtual,
        phone_manufacturer: deviceInfo.manufacturer,
        phone_model: deviceInfo.model,
        phone_operatingsystem: deviceInfo.operatingSystem,
        phone_osversion: deviceInfo.osVersion,
        phone_platform: deviceInfo.platform,
        phone_uuid: deviceId.uuid,
      }
    ).then(res => {
      // console.log('Added new Token', res);
    });
  }
}
